
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import TemplateList from "./TemplateList.vue";
import MainList from "./MainList.vue";
import ParamsDocumentation from "./ParamsDocumentation.vue";
// @ts-ignore
import * as FooterData from "../../../artefacts/footerData.json";
import RouteName from "../router/NameEnum";

@Component({
    components: {
        TemplateList,
        MainList,
        ParamsDocumentation
    }
})
export default class MainLayout extends HcPageModel {
    @Prop({ type: Boolean, default: true }) private displayTemplate!: boolean;
    @Prop({ type: Boolean, default: true }) private displayMain!: boolean;

    public name: string = "main-layout";
    private showModal: boolean = false;
    private routeName = RouteName;

    static readonly gitlabPrefix: string = "https://git.homecredit.cz/dev/tools/loki/";
    static readonly gitlabCommit: string = "commit/";
    static readonly gitlabBranch: string = "tree/";

    private loadTemplate(template: string): void {
        this.$emit("loadTemplate", template);
    }

    private clearForm(): void {
        this.$emit("clearForm");
    }

    private sendForm(): void {
        this.$emit("sendForm");
    }

    private get jenkinsJobUrl(): string {
        return FooterData.jenkinsJobUrl;
    }

    private get gitCommit(): string {
        return FooterData.gitCommit;
    }

    private get gitCommitUrl(): string {
        return `${MainLayout.gitlabPrefix}${MainLayout.gitlabCommit}${this.gitCommit}`;
    }

    private get gitBranch(): string {
        return FooterData.gitBranch;
    }

    private get gitBranchUrl(): string {
        return `${MainLayout.gitlabPrefix}${MainLayout.gitlabBranch}${this.gitBranch}`;
    }

    private get jenkinsJobStart(): string {
        return FooterData.jenkinsJobStart;
    }
}
